module.exports = __webpack_public_path__ + "img/mady-morrison.70b3be92.jpg";